import { Navigate, Route, Routes } from 'react-router-dom';
import { useApp } from './contexts/AppContext';
import { Layout } from './components/layout/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { MaintenancePage } from './pages/MaintenancePage';
import { TenantsPage } from './pages/TenantsPage';
import { UsersPage } from './pages/UsersPage';
import { GroupsPage } from './pages/GroupsPage';
import { WorkspacesPage } from './pages/WorkspacesPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { IdentityProvidersPage } from './pages/IdentityProvidersPage';
import { CostsPage } from './pages/CostsPage';
import { BuilderPage } from './pages/BuilderPage';
import { AgentsPage } from './pages/AgentsPage';
import { AgentDetailPage } from './pages/AgentDetailPage';
import { OrgPage } from './pages/OrgPage';
import { ToolsPage } from './pages/ToolsPage';
import { SkillsPage } from './pages/SkillsPage';
import { WorkflowTypesPage } from './pages/WorkflowTypesPage';
import { TaxonomyPage } from './pages/TaxonomyPage';
import { TriggersPage } from './pages/TriggersPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { McpPage } from './pages/McpPage';
import { KnowledgePage } from './pages/KnowledgePage';
import { CollaboratePage } from './pages/CollaboratePage';
import { MailboxPage } from './pages/MailboxPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { RunsPage } from './pages/RunsPage';
import { ReportsPage } from './pages/ReportsPage';
import { ReviewPage } from './pages/ReviewPage';
import { ApprovalsPage } from './pages/ApprovalsPage';
import { EvalsPage } from './pages/EvalsPage';
import { LearningPage } from './pages/LearningPage';

function Shell({ children }: { children: React.ReactNode }) {
  const { maintenance } = useApp();
  if (maintenance) return <MaintenancePage />;
  return <Layout>{children}</Layout>;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/customers" element={<Navigate to="/tenants" replace />} />
      <Route path="/admin/groups" element={<Navigate to="/groups" replace />} />
      <Route path="/maintenance" element={<MaintenancePage />} />
      <Route path="/dashboard" element={<Shell><DashboardPage /></Shell>} />
      <Route path="/tenants" element={<Shell><TenantsPage /></Shell>} />
      <Route path="/users" element={<Shell><UsersPage /></Shell>} />
      <Route path="/groups" element={<Shell><GroupsPage /></Shell>} />
      <Route path="/workspaces" element={<Shell><WorkspacesPage /></Shell>} />
      <Route path="/settings" element={<Shell><SettingsPage /></Shell>} />
      <Route path="/admin/settings" element={<Shell><AdminSettingsPage /></Shell>} />
      <Route path="/admin/identity-providers" element={<Shell><IdentityProvidersPage /></Shell>} />
      <Route path="/costs" element={<Shell><CostsPage /></Shell>} />
      <Route path="/builder" element={<Shell><BuilderPage /></Shell>} />
      <Route path="/agents" element={<Shell><AgentsPage /></Shell>} />
      <Route path="/agents/:id" element={<Shell><AgentDetailPage /></Shell>} />
      <Route path="/org" element={<Shell><OrgPage /></Shell>} />
      <Route path="/tools" element={<Shell><ToolsPage /></Shell>} />
      <Route path="/skills" element={<Shell><SkillsPage /></Shell>} />
      <Route path="/workflow-types" element={<Shell><WorkflowTypesPage /></Shell>} />
      <Route path="/taxonomy" element={<Shell><TaxonomyPage /></Shell>} />
      <Route path="/triggers" element={<Shell><TriggersPage /></Shell>} />
      <Route path="/integrations" element={<Shell><IntegrationsPage /></Shell>} />
      <Route path="/mcp-servers" element={<Shell><McpPage /></Shell>} />
      <Route path="/knowledge" element={<Shell><KnowledgePage /></Shell>} />
      <Route path="/collaborate" element={<Shell><CollaboratePage /></Shell>} />
      <Route path="/mailbox" element={<Shell><MailboxPage /></Shell>} />
      <Route path="/payments" element={<Shell><PaymentsPage /></Shell>} />
      <Route path="/runs" element={<Shell><RunsPage /></Shell>} />
      <Route path="/reports" element={<Shell><ReportsPage /></Shell>} />
      <Route path="/review" element={<Shell><ReviewPage /></Shell>} />
      <Route path="/approvals" element={<Shell><ApprovalsPage /></Shell>} />
      <Route path="/evals" element={<Shell><EvalsPage /></Shell>} />
      <Route path="/learning" element={<Shell><LearningPage /></Shell>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
